import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';

tippy('[data-tippy-content]',{
  allowHTML: true,
  arrow: true,
  placement: 'bottom',
  trigger: 'mouseover click',
  interactive: true,
  interactiveBorder: 15,
  theme: 'light'
});